import { useEffect, useState } from 'react'

import { readSlideViewMode, SlideViewMode, writeSlideViewMode } from './slide-view'

export const useSlideViewMode = () => {
  const [viewMode, setViewMode] = useState<SlideViewMode>(() =>
    readSlideViewMode(typeof window === 'undefined' ? null : window.localStorage)
  )

  useEffect(() => {
    writeSlideViewMode(typeof window === 'undefined' ? null : window.localStorage, viewMode)
  }, [viewMode])

  return { viewMode, setViewMode }
}
